import React, { useState } from "react";
import toast from "react-hot-toast";
import { ISingleProduct } from "./constants";
import { MenuDrawer } from "../../../../components/MenuOptions";
import { ConfirmDeleteModal } from "./ConfirmDelete";
import { ConfirmationDialog } from "../../../../components/ConfirmationDialog/ConfirmationDialog";
import { ProductV2Modal } from "../productModal";
import axiosInstant from "../../../../api";
import { deleteProductAdmin } from "../../../../api/endpoints";
import { canDeleteProduct, productCannotDeleteMessage } from "../../../../utils";
import { useUser } from "../../../../hooks/useUser";

interface Props {
  product: ISingleProduct;
  onClose?: () => void;
  onUpdate?: () => void;
  onDelete?: () => void;
  onProductUpdate?:  () => void;
  isDetailedPage?: boolean;
}

export function ProductMenu({ product, onClose, onUpdate, onDelete, isDetailedPage, onProductUpdate }: Props) {
  const { role } = useUser();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showCannotDeleteDialog, setShowCannotDeleteDialog] = useState(false);
  const [cannotDeleteCounts, setCannotDeleteCounts] = useState({ projectCount: 0, videoCount: 0 });

  const deleteProduct = () => {
    axiosInstant
      .delete(deleteProductAdmin(product.desireid))
      .then(() => {
        toast.success("Product deleted successfully!");
        setShowDeleteModal(false);
        onUpdate?.();
        onDelete?.();
        onClose?.();
      })
      .catch((error) => {
        setShowDeleteModal(false);
        if (error.response?.status === 409) {
          const body = error.response.data || {};
          setCannotDeleteCounts({
            projectCount: body.projectCount || 0,
            videoCount: body.videoCount || 0,
          });
          setShowCannotDeleteDialog(true);
        } else {
          toast.error("Product deletion failed. Please try again.");
        }
      });
  };

  return (
    <>
      <MenuDrawer
        title="product"
        id={product.desireid}
        isDetailedPage={isDetailedPage}
        showDelete={canDeleteProduct(role)}
        onDelete={() => setShowDeleteModal(true)}
        onEdit={() => setShowProductModal(true)}
        onMenuClose={onClose}
      />
      <ConfirmDeleteModal
        show={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onOkay={deleteProduct}
      />
      <ConfirmationDialog
        open={showCannotDeleteDialog}
        onClose={() => setShowCannotDeleteDialog(false)}
        onConfirm={() => setShowCannotDeleteDialog(false)}
        title="Delete Product"
        description={productCannotDeleteMessage(cannotDeleteCounts)}
        confirmLabel="Continue"
        cancelLabel=""
        showDivider={false}
      />
      {showProductModal && (
        <ProductV2Modal
          product={product}
          onClose={() => setShowProductModal(false)}
          onComplete={() => {
            setShowProductModal(false);
            onUpdate?.();
            onProductUpdate?.();
          }}
        />
      )}
    </>
  );
}
